export default Object.freeze({
    MONTHLY: 'MONTHLY',
    ANNUALLY: 'ANNUALLY',
})
